import {
  ExperimentName,
  RELEASE_SWITCH_TOGGLE,
  RELEASE_TOGGLE_ERX,
  RELEASE_TOGGLE_MARKETPLACE,
  RELEASE_TOGGLE_SAE_ONLY,
  RELEASE_TOGGLE_NOW
} from 'shared/experiments/consts'
import { Experiment } from 'types/shopConfig'

export const isExperimentVariableTrue = (
  key: ExperimentName,
  variable: string,
  experiments: Experiment[] = []
): boolean => {
  const experiment = experiments.find(e => e.name === key)
  if (!experiment?.isEnabled) {
    return false
  }

  return experiment?.variables?.[variable] === true
}

export const isSaeOnly = (experiments: Experiment[] = []): boolean =>
  isExperimentVariableTrue(
    RELEASE_SWITCH_TOGGLE,
    RELEASE_TOGGLE_SAE_ONLY,
    experiments
  )

export const isMarketplace = (experiments: Experiment[] = []): boolean =>
  isExperimentVariableTrue(
    RELEASE_SWITCH_TOGGLE,
    RELEASE_TOGGLE_MARKETPLACE,
    experiments
  )

export const isERx = (experiments: Experiment[] = []): boolean =>
  isExperimentVariableTrue(
    RELEASE_SWITCH_TOGGLE,
    RELEASE_TOGGLE_ERX,
    experiments
  )

export const isNow = (experiments: Experiment[] = []): boolean =>
  isExperimentVariableTrue(
    RELEASE_SWITCH_TOGGLE,
    RELEASE_TOGGLE_NOW,
    experiments
  )
